import { createUseStyles } from "react-jss";
import { getSpacing } from "../../../theme/Mixins";

export default createUseStyles({
    navigation: {
        bottom: 0,
        composes: "navigation",
        left: 0,
        margin: ({ theme }) =>
            theme.BottomNavigationPosition === "floating" ? [[0, 0]] : 
            [[getSpacing(theme, 29, theme.QuestionSpacing?.BetweenComponents), -6, 0, -6]],
        padding: ({ theme }) => [[getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents), 0]],
        position: ({ theme }) => theme.BottomNavigationPosition === "floating" && "fixed",
        right: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    navigationLeft: {
        marginRight: "5%",
        flex: "1 1 auto",
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "nowrap",
        "& > .button": {
            flexBasis: "0 0 auto",
            margin: [["0%", "8px"]],
            padding: [[0, 12]],
            maxWidth: "60%",
        },
        maxWidth: "50%",
    },
    navigationCenter: {
        flex: "1 1 auto",
        display: "flex",
        justifyContent: "center",
        flexWrap: "nowrap",
        "& > .button": {
            flexBasis: "0 0 auto",
            margin: [["0%", "8px"]],
            padding: [[0, 12]],
            maxWidth: "60%",
        },
        maxWidth: "50%",
    },
    navigationRight: {
        marginLeft: "5%",
        flex: "1 1 auto",
        display: "flex",
        flexWrap: "nowrap",
        justifyContent: "flex-end",
        "& > .button": {
            flexBasis: "0 0 auto",
            margin: [["0%", "8px"]],
            padding: [[0, 12]],
            maxWidth: "60%",
        },
        maxWidth: "50%",
    },
    navigationButtonContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        textAlign: "center",
        "& .button": {
            margin: ({ theme }) => theme.BottomNavigationPosition === "floating" && 0,
            borderRadius: ({ theme }) => theme.BottomNavigationPosition === "floating" && 0,
        },
    },
    navigationPlaceHolder: {
        display: "flex",
    }
});
